<template>
  <div class="touxi">
    <div class="header">
      <titleCard title="透析中心建设" class="animate__animated wow animate__fadeInUp"></titleCard>
      <p class="header-title animate__animated wow animate__fadeInUp">
        顺应国家政策，发挥自身优势，同时向医院提供“资金、设备、技术、人员、运营”五大服务，“一站式”实现社区血液透析中心的标准化建设。
      </p>
      <div class="header-box">
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="0.6s">
          <div class="pic-box"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/27A9585C232D4D8BA459A5B262E90DC0-6-2.png"></div>
          <div class="text-box">
            <div class="icon"><img src="../../assets/image/innovatc/touxi4.webp" alt=""></div>
            <p>全流程标准服务输出</p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="0.8s">
          <div class="pic-box"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/019F2AE952874E95AA8927D25E0FB0F1-6-2.png"></div>
          <div class="text-box">
            <div class="icon"><img src="../../assets/image/innovatc/touxi5.webp" alt=""></div>
            <p>专业级团队合作运营</p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1s">
          <div class="pic-box"><img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/FEA4812419284CA7A697638E50D20F3C-6-2.png"></div>
          <div class="text-box">
            <div class="icon"><img src="../../assets/image/innovatc/touxi6.webp" alt=""></div>
            <p>智能化血透管理系统</p>
          </div>
        </div>
      </div>
    </div>
    <div class="main animate__animated wow animate__fadeIn">
      <div class="title">
        <div class="titleCard">
          <p>透析领域综合服务商</p>
          <span></span>
        </div>
      </div>
      <div class="main-boxs">
        <div class="box animate__animated wow animate__fadeInLeft" data-wow-duration="1.6s">
          <div class="pic"><img src="../../assets/image/innovatc/touxi4.webp"></div>
          <h4>规划</h4>
          <h3>可行性分析、立项、筹建</h3>
          <span></span>
          <p>市场调研<br> 选址、设计、施工、验收</p>
        </div>
        <div class="box animate__animated wow animate__fadeInLeft" data-wow-duration="1.4s">
          <div class="pic"><img src="../../assets/image/innovatc/touxi5.webp"></div>
          <h4>筹备</h4>
          <h3>供应链服务、临床筹备、验收</h3>
          <span></span>
          <p>采购、医护培训、管理文件编撰<br>信息化管理平台、患者导入<br>质控和院感评审检查</p>
        </div>
        <div class="box animate__animated wow animate__fadeInLeft" data-wow-duration="1.2s">
          <div class="pic"><img src="../../assets/image/innovatc/touxi6.webp"></div>
          <h4>运营</h4>
          <h3>开业运行、运营支持</h3>
          <span></span>
          <p>资深医护技驻地帮扶<br>健康宣教<br>应急状况指导</p>
        </div>
      </div>
    </div>
    <div class="footer animate__animated wow animate__fadeInUp">
      <div class="footer-title">
        <titleCard title="服务案例"></titleCard>
      </div>
      <div class="footer-content">
        <el-carousel :interval="3000" arrow="always" type="card" trigger='click' :autoplay='IsAutoplay'>
          <el-carousel-item v-for="(item,index) in fuwuList" :key="index">
            <img :src="item" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="footer-text animate__animated wow animate__fadeIn">
      <h4>以服务输出为宗旨，致力于学科建设、技术创新和优质服务</h4>
      <h3>为肾友保驾护航！</h3>
    </div>
    <footerCard name="吉老师" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'

export default {
  data() {
    return {
      IsAutoplay: false,
      screenWidth: document.body.clientWidth,
      fuwuList: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/37D95D11E6944174B0B9C33593FB8168-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/B16A693B0C8D409D8B9971767DC2A828-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/54E4942F187144449F20B5B2F5EB0B4B-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/F96A6629133F41BA8FF80F1E1127C13E-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/49F7588942084FADBD90F93823F9C214-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/81D1879D059944EFBB121BF72B94A4CA-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/C09044B2603F470BA3F0F817A70E5E71-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/99EB03D39743409F9DC627EB8442A229-6-2.png",
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/DD6F24E6884548BA801CE7D347C928F9-6-2.png",
      ]
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {
    if (this.screenWidth < 540) {
      this.IsAutoplay = true
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.touxi {
  .header {
    padding: 1.3684rem 0 1.0526rem;
    .header-title {
      margin: 0;
      padding: 0.5263rem 0 0.7368rem 0;
      text-align: center;
      width: 50%;
      margin: 0 auto;
      color: #000;
      font-size: 0.2526rem;
      line-height: 0.5263rem;
      @media screen and (max-width: 540px) {
        line-height: 1.2632rem;
        width: 80%;
        font-size: 13px;
        padding: 30px 0;
      }
    }
    .header-box {
      display: flex;
      justify-content: center;
      padding-bottom: 2.0526rem;
      .box {
        width: 5.4737rem;
        margin: 0 0.0842rem;
        @media screen and (max-width: 540px) {
          // height: 85px;
          width: 30%;
        }
        .pic-box {
          height: 3.7895rem;
          margin-bottom: 0.2947rem;
          @media screen and (max-width: 540px) {
            height: 85px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text-box {
          height: 2.3158rem;
          border: 1px solid #eaeaea;
          display: flex;
          justify-content: center;
          align-items: center;
          @media screen and (max-width: 540px) {
            height: 138px;
            flex-wrap: wrap;
            // display: block;
          }
          .icon {
            width: 0.8105rem;
            height: 0.8105rem;
            padding-right: 0.3895rem;
            @media screen and (max-width: 540px) {
              width: 38px;
              height: 38px;
              padding-right: 0;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
          p {
            font-size: 0.3158rem;
            color: #333333;
            font-weight: 700;
            @media screen and (max-width: 540px) {
              font-size: 15px;
              padding: 0 20px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .main {
    height: 10.3158rem;
    @media screen and (max-width: 540px) {
      height: 500px;
    }
    background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/74EFD9FCE68F42CD9689878A6FC2653E-6-2.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 1.5789rem;
    .title {
      padding: 1.2632rem 0 1.1579rem 0;
      .titleCard {
        text-align: center;
        p {
          padding-bottom: 0.3789rem;
          font-size: 0.4421rem;
          font-weight: 700;
          color: #fff;
          letter-spacing: 0.0526rem;
          @media screen and (max-width: 540px) {
            font-size: 21px;
          }
        }
        span {
          margin: 0 auto;
          position: relative;
          display: block;
          width: 3.0947rem;
          height: 0.0421rem;
          background-color: #ffffff;
          @media screen and (max-width: 540px) {
            width: 9.4737rem;
            height: 0.1263rem;
          }
        }
        span::after {
          content: '';
          position: absolute;
          left: 50%;
          margin-left: -0.2947rem;
          bottom: -0.0105rem;
          width: 0.5895rem;
          height: 0.0842rem;
          background-color: #fff;
          @media screen and (max-width: 540px) {
            width: 1.6842rem;
            height: 0.2211rem;
            bottom: -0.0316rem;
            margin-left: -0.8421rem;
          }
        }
      }
    }
    .main-boxs ::-webkit-scrollbar {
      display: none;
    }
    .main-boxs {
      display: flex;
      justify-content: center;
      @media screen and (max-width: 540px) {
        overflow-x: scroll;
        justify-content: left;
        margin: 0 10px;
      }

      .box {
        width: 4.7158rem;
        box-shadow: 1px 1px 1px rgba(255, 255, 255, 0.658);
        height: 5.6842rem;
        margin: 0 0.1263rem;
        background-color: #fff;
        text-align: center;
        @media screen and (max-width: 540px) {
          height: 280px;
          flex-basis: 250px;
          flex-shrink: 0;
          margin: 0 10px;
        }
        .pic {
          margin: 0 auto;
          padding-top: 0.2842rem;
          width: 1.1368rem;
          height: 1.1368rem;
          @media screen and (max-width: 540px) {
            width: 54px;
            height: 54px;
            padding-top: 18px;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }
        h4 {
          color: #333333;
          font-size: 0.2947rem;
          font-weight: 700;
          @media screen and (max-width: 540px) {
            font-size: 14px;
          }
        }
        h3 {
          font-weight: 700;
          font-size: 0.2526rem;
          color: #0ca6eb;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
        span {
          display: block;
          margin: 0 auto;
          background-color: #0ca6eb;
          height: 0.0105rem;
          width: 80%;
          margin-bottom: 0.6316rem;
        }
        p {
          font-size: 0.2526rem;
          color: #666666;
          line-height: 0.4211rem;
          @media screen and (max-width: 540px) {
            line-height: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .footer {
    .footer-title {
      padding: 0 0 1.7895rem 0;
    }
    .footer-content {
      padding: 0 2.7158rem;
      height: 4.5895rem;
      padding-bottom: 2rem;
      @media screen and (max-width: 540px) {
        height: 160px;
        padding: 0;
        padding-bottom: 54px;
      }
      .el-carousel__item img {
        height: 100%;
        width: 100%;
      }
      /deep/ .el-carousel__container {
        height: 90%;
      }
      /deep/ .el-carousel__arrow {
        @media screen and (max-width: 540px) {
          display: none;
        }
        height: 0.5263rem;
        background-color: #ffffff8e;
        width: 0.5263rem;
        border: 0.0211rem solid #c6c6c6;
        color: #c6c6c6;
        font-size: 0.2737rem;
      }
      /deep/ .el-carousel__indicators {
        @media screen and (max-width: 540px) {
          display: none;
        }
      }
      /deep/ .el-carousel--horizontal {
        height: 100%;
      }
      // /deep/ .el-carousel__arrow--left {
      //   left: -80px;
      // }
      // /deep/ .el-carousel__arrow--right {
      //   right: -80px;
      // }
      /deep/ .el-carousel__button {
        height: 0.0842rem;
        width: 0.3158rem;
        background-color: #c3c3c3;
      }
      /deep/ .el-carousel__indicator.is-active button {
        background-color: #0ca6eb;
      }
      /deep/ .el-carousel__indicator--horizontal {
        padding: 0 0.0421rem;
        padding-top: 0.3158rem;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
  }
  .footer-text {
    height: 2.2105rem;
    background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/80110D38C9F741F3A21B22BF47193B44-6-2.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: -0.0211rem;
    text-align: center;
    color: #fff;
    font-size: 0.3579rem;
    @media screen and (max-width: 540px) {
      height: 106px;
      font-size: 15px;
    }
    h4 {
      font-weight: 500;
      margin: 0;
      padding: 0.6947rem 0 0.1053rem 0;
      @media screen and (max-width: 540px) {
        padding: 33px 0 10px 0;
      }
    }
    h3 {
      font-weight: 800;
      margin: 0;
    }
  }
}
</style>
